<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.1569 9.34305V6.65674H17.1569V7.9999H15.8433V6.65674H13.1569V7.9999H11.8433V6.65674H9.15695V7.9999H7.84326V6.65674H5.84326V9.34305H19.1569Z"
      fill="white"
    />
    <path d="M19.1548 10.6567H5.84326V18.6567H19.1548V10.6567Z" fill="white" />
    <path
      d="M17.1568 5.34316H20.5V20H4.5V5.34316H7.84316V4H9.15474V5.34316H11.8432V4H13.1547V5.34316H15.8432V4H17.1547V5.34316H17.1568ZM19.1568 9.34316V6.65684H17.1568V8H15.8432V6.65684H13.1568V8H11.8432V6.65684H9.15684V8H7.84316V6.65684H5.84316V9.34316H19.1568ZM19.1568 18.6568V10.6568H5.84316V18.6568H19.1568Z"
      class="fill-current"
    />
    <path d="M11.7756 12.3706H10.3271V13.2843H11.7756V12.3706Z" class="fill-current" />
    <path d="M8.88104 12.3706H7.43262V13.2843H8.88104V12.3706Z" class="fill-current" />
    <path d="M14.6725 12.3706H13.2241V13.2843H14.6725V12.3706Z" class="fill-current" />
    <path d="M17.5671 12.3706H16.1187V13.2843H17.5671V12.3706Z" class="fill-current" />
    <path d="M11.7756 14.1978H10.3271V15.1114H11.7756V14.1978Z" class="fill-current" />
    <path d="M8.88104 14.1978H7.43262V15.1114H8.88104V14.1978Z" class="fill-current" />
    <path d="M14.6725 14.1978H13.2241V15.1114H14.6725V14.1978Z" class="fill-current" />
    <path d="M17.5671 14.1978H16.1187V15.1114H17.5671V14.1978Z" class="fill-current" />
    <path d="M11.7756 16.0254H10.3271V16.9391H11.7756V16.0254Z" class="fill-current" />
    <path d="M8.88104 16.0254H7.43262V16.9391H8.88104V16.0254Z" class="fill-current" />
    <path d="M14.6725 16.0254H13.2241V16.9391H14.6725V16.0254Z" class="fill-current" />
    <path d="M17.5671 16.0254H16.1187V16.9391H17.5671V16.0254Z" class="fill-current" />
  </svg>
</template>
